"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteObjectTaggingOutput = {
    type: "structure",
    required: [],
    members: {
        VersionId: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-version-id"
        }
    }
};
//# sourceMappingURL=DeleteObjectTaggingOutput.js.map